<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>교육 신청</p></li>
            <li><p>교육 신청</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>외식 경영 관리사 시험 신청 </span>
          </h1>
        </div>
        <div class="page_con">
          <div class="form_table">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl_big">
                    <p>
                      {{ item.examinationName }}
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="id_picture_wrap">
                    <div class="inform_btn">
                      <button class="btn bo" @click="fnModalInfo">
                        안내사항 확인
                      </button>
                    </div>
                    <div class="id_picture">
                      <div class="thumb">
                        <div class="inner">
                          <img
                            :src="base64Profile"
                            v-show="!$Util.isEmpty(base64Profile)"
                          />
                        </div>
                        <p class="valid" :class="{ on: $v.profileFile.$error }">
                          필수항목입니다.
                        </p>
                        <!--'on 추가'-->
                      </div>
                      <div class="inform_box">
                        <div>
                          <span class="color bold">사진 안내</span>
                          <ol class="dot">
                            <li class="color">
                              <span class="ol_li_txt"
                                >사진은 3cmx4cm로 업로드 하시기 바랍니다.</span
                              >
                            </li>
                            <li class="color">
                              <span class="ol_li_txt"
                                >파일형식은 jpg, png만 가능합니다.</span
                              >
                            </li>
                          </ol>
                          <input
                            type="file"
                            accept="image/*"
                            ref="profile"
                            style="display: none"
                            v-on:change="this.fnChangeSelectFile"
                            onclick="this.value=null"
                          />
                          <button class="btn" @click="$refs['profile'].click()">
                            사진 업로드
                          </button>
                        </div>
<!--                        <p class="valid" :class="{ on: $v.certFile.$error }">-->
<!--                          필수항목입니다.-->
<!--                        </p>-->
                      </div>
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>시험명</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.examinationName }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>수험번호</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">신청 시 발급 됩니다.</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>시험 구분</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ `${item.rating}급 ${item.part}` }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>시험 장소</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.examAddress }}</p>
                  </div>
                </li>
                <li class="form_li top_bo">
                  <div class="form_ttl">
                    <p class="essen">이름(한글)</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="이름을 입력해 주세요"
                        v-model="form.koName"
                      />
                      <p class="valid" :class="{ on: $v.form.koName.$error }">
                        이름을 입력해 주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">이름(영문)</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="영문 이름을 입력해 주세요"
                        v-model="form.enName"
                      />
                      <p class="valid" :class="{ on: $v.form.enName.$error }">
                        이름을 입력해 주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">생년월일</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="생년월일을 입력해 주세요"
                        v-model="form.userBirth"
                        maxlength = "8"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <p class="hint">
                        생년월일 8자리(ex: 20200131)를 입력해 주세요.
                      </p>
                      <p
                        class="valid"
                        :class="{ on: $v.form.userBirth.$error }"
                      >
                        생년월일을 입력해 주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">성별</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="radio">
                        <input
                          type="radio"
                          name="a"
                          id="aa"
                          :value="1"
                          v-model="form.gender"
                        />
                        <label for="aa"><span>남</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="a"
                          id="ab"
                          :value="2"
                          v-model="form.gender"
                        />
                        <label for="ab"><span>여</span></label>
                      </div>
                    </div>
                    <p class="valid" :class="{ on: $v.form.gender.$error }">
                      필수항목입니다.
                    </p>
                    <!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">이메일</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="email"
                        placeholder="이메일을 입력해 주세요"
                        v-model="form.email"
                      />
                      <p class="valid" :class="{ on: $v.form.email.$error }">
                        이메일을 입력해 주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">주소</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="input">
                        <input
                          type="number"
                          placeholder="우편 번호"
                          disabled
                          v-model="form.postCode"
                        />
                      </div>
                      <button
                        class="btn bo"
                        @click="
                          $store.commit('layout/setModalAlert', {
                            modalAlertName:
                              $modalAlertNames.MODAL_DAUM_POST_CODE,
                            callBack: fnBind
                          })
                        "
                      >
                        주소 검색
                      </button>
                    </div>
                    <div class="input">
                      <input
                        type="text"
                        placeholder="주소를 입력해 주세요"
                        disabled
                        v-model="form.userAddr"
                      />
                    </div>
                    <div class="input">
                      <input
                        type="text"
                        placeholder="상세주소를 입력해 주세요"
                        v-model="form.userAddr2"
                      />
                    </div>
                    <p class="valid" :class="{ on: $v.form.userAddr.$error }">
                      주소를 입력해 주세요.
                    </p>
                    <!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">휴대폰 번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="-를 제외하고 입력해 주세요"
                        v-model="form.userPhone"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <p
                        class="valid"
                        :class="{ on: $v.form.userPhone.$error }"
                      >
                        휴대폰 번호를 입력해 주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">자격 증명</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="inline">
                        <div class="radio">
                          <input
                            type="radio"
                            name="b"
                            id="ba"
                            :value="1"
                            v-model="qualificationType"
                          >
                          <label for="ba"><span>실무 경력</span></label>
                        </div>
                        <div class="radio">
                          <input
                            type="radio"
                            name="b"
                            id="bb"
                            :value="2"
                            v-model="qualificationType"
                          >
                          <label for="bb"><span>최종학력</span></label>
                        </div>
                      </div>
                      <button class="btn bo" @click="fnModalCert">
                        자격확인
                      </button>
                    </div>
                    <p
                      class="valid"
                      :class="{ on: $v.form.qualificationType.$error }"
                    >
                      필수항목입니다.
                    </p>
                    <!--'on 추가'-->
                    <div class="inline" v-show="qualificationType === 2">
                      <div class="radio">
                        <input
                          type="radio"
                          name="c"
                          id="ca"
                          :value="1"
                          v-model="form.academyType"
                        />
                        <label for="ca"><span>대학원</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="c"
                          id="cb"
                          :value="2"
                          v-model="form.academyType"
                        />
                        <label for="cb"><span>대학교(4년제)</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="c"
                          id="cc"
                          :value="3"
                          v-model="form.academyType"
                        />
                        <label for="cc"><span>전문대(2년제)</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="c"
                          id="cd"
                          :value="4"
                          v-model="form.academyType"
                        />
                        <label for="cd"><span>고등학교</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="c"
                          id="ce"
                          :value="5"
                          v-model="form.academyType"
                        />
                        <label for="ce"><span>기타</span></label>
                      </div>
                    </div>
                    <p
                      class="valid"
                      :class="{ on: $v.form.academyType.$error }"
                    >
                      필수항목입니다.
                    </p>
                    <!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li" v-show="qualificationType === 1">
                  <div class="form_ttl">
                    <p>담당 업무</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="담당했던 업무를 작성해 주세요"
                        v-model="form.work"
                      />
                    </div>
                    <p class="valid" :class="{ on: $v.form.work.$error }" >필수항목입니다.</p><!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li" v-show="qualificationType === 1" :key="currentIndex">
                  <div class="form_ttl">
                    <p>근무 기간</p>
                  </div>
                  <div class="form_in">
                    <div class="inline period">
                      <div class="datepicker">
                        <custom-datepicker
                          :placeholder="'YYYY.MM.DD'"
                          :format="'yyyy.MM.dd'"
                          v-model="form.workStartDate"
                        />
                      <p class="valid" :class="{ on: $v.form.workStartDate.$error }">필수항목입니다.</p>
                      </div>
                      <div class="from_to">~</div>
                      <div class="datepicker">
                        <custom-datepicker
                          :placeholder="'YYYY.MM.DD'"
                          :format="'yyyy.MM.dd'"
                          v-model="form.workEndDate"
                        />
                      <p class="valid" :class="{ on: $v.form.workEndDate.$error }">필수항목입니다.</p>
                      </div>
                      <div class="input">
                        <input
                          type="text"
                          placeholder="0년 0개월"
                          readonly
                          :value="`${diffYear}년 ${diffMonth}개월`"
                        />
                      </div>
                    </div>
                  </div>
                </li>
                <li class="form_li" v-show="qualificationType === 2">
                  <div class="form_ttl">
                    <p>학교(기관)명</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="학교(기관)명을 입력해 주세요"
                        v-model="form.academyName"
                      />
                    </div>
                    <p class="valid" :class="{ on: $v.form.academyName.$error }">필수항목입니다.</p><!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li" v-show="qualificationType === 2">
                  <div class="form_ttl">
                    <p>전공(학과)</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="전공(학과)를 입력해 주세요"
                        v-model="form.major"
                      />
                    </div>
                    <p class="valid" :class="{ on: $v.form.major.$error }">필수항목입니다.</p><!--'on 추가'-->
                    <div class="inline">
                      <div class="radio">
                        <input
                          type="radio"
                          name="d"
                          id="da"
                          :value="1"
                          v-model="form.completedType"
                        />
                        <label for="da"><span>졸업</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="d"
                          id="db"
                          :value="2"
                          v-model="form.completedType"
                        />
                        <label for="db"><span>재학</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="d"
                          id="dc"
                          :value="3"
                          v-model="form.completedType"
                        />
                        <label for="dc"><span>수료</span></label>
                      </div>
                      <div class="radio">
                        <input
                          type="radio"
                          name="d"
                          id="dd"
                          :value="4"
                          v-model="form.completedType"
                        />
                        <label for="dd"><span>중퇴</span></label>
                      </div>
                    </div>
                    <p class="valid" :class="{ on: $v.form.completedType.$error }">필수항목입니다.</p><!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">교육수료여부</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          id="c"
                          :true-value="1"
                          :false-value="2"
                          v-model="form.isSelected"
                        />
                        <label for="c"><span>지정기관 교육 수료</span></label>
                      </div>
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          id="d"
                          :true-value="1"
                          :false-value="2"
                          v-model="form.isKfood"
                        />
                        <label for="d"
                          ><span>(사)한국외식산업협회 교육 수료</span></label
                        >
                      </div>
                    </div>
                    <p
                      class="valid"
                      :class="{ on: $v.form.isSelected.$error }"
                    >
                      필수항목입니다.
                    </p>
                    <div class="inform_box mtb10">
                      <span class="color bold">제출서류</span>
                      <ol class="dot">
                        <li class="color">
                          <span class="ol_li_txt"
                            >실무 경력: 재직증명서 혹은 4대보험 가입확인서(jpg,
                            png, gif, pdf)</span
                          >
                        </li>
                        <li class="color">
                          <span class="ol_li_txt"
                            >최종 학력: 재학증명서 혹은 졸업증명서(jpg, png,
                            gif, pdf)</span
                          >
                        </li>
                      </ol>
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">파일 업로드</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="input">
                        <input
                          type="text"
                          v-model="certFile.name"
                          placeholder="자격 증명 파일을 업로드"
                        />
                        <input
                          ref="fileEl"
                          type="file"
                          style="display: none"
                          @change="fnFileChange"
                          @click="() => (certFile = '')"
                        />
                      </div>
                      <button
                        class="btn bo"
                        @click="() => $refs['fileEl'].click()"
                      >
                        파일 선택
                      </button>
                    </div>
                    <p class="valid" :class="{ on: $v.certFile.$error }">필수항목입니다.</p><!--'on 추가'-->
                  </div>
                </li>
                <li class="form_li">
                  <div class="inform_box mtb10">
                    <ol class="dot">
                      <li class="color">
                        <span class="ol_li_txt">
                          시험신청서에 기재한 내용이 틀리거나 시험자격기준에
                          해당하지 아니한 경우에는 합격 또는 자격을 취소하여도
                          아무런 이의를 제기하지 아니하겠습니다.
                        </span>
                      </li>
                      <li class="color">
                        <span class="ol_li_txt">
                          본인의 귀책사유로 인하여 수료증이 오발송되는 경우,
                          재발급 비용이 추가로 발생되는 것에 이의를 제기하지
                          아니하겠습니다.
                        </span>
                      </li>
                    </ol>
                  </div>
                </li>
                <li class="form_li">
                  <div class="check_list">
                    <div class="check_list_li">
                      <div class="checkbox">
                        <input
                          type="checkbox"
                          id="a"
                          :true-value="1"
                          :false-value="2"
                          :checked="form.isAgree"
                          v-model="form.isAgree"
                        />
                        <label for="a"
                          ><span class="essen"
                            >위 약관의 내용에 동의합니다</span
                          ></label
                        >
                        <p
                          class="valid"
                          :class="{ on: $v.form.isAgree.$error }"
                        >
                          약관에 동의해주세요.
                        </p>
                        <!--'on 추가'-->
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn" @click="fnModal">
            시험 신청하기
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'manager-edu-apply-write-index',
  data: function() {
    const examinationNo = Number(this.$route.query.examinationNo)
    return {
      examinationNo,
      item: {},
      profileFile: '', // file object
      base64Profile: '', // file base64
      certFile: '', // 자격증명 file,
      qualificationType: 1,
      form: {
        userProfile: '',
        koName: '',
        enName: '',
        userBirth: '',
        gender: 1,
        email: '',
        userAddr: '',
        userAddr2: '',
        postCode: '',
        userPhone: '',
        qualificationType: 1,
        work: '',
        workStartDate: '',
        workEndDate: '',
        workMonth: '',
        academyType: '',
        academyName: '',
        major: '',
        completedType: '',
        isSelected: '', // 지정기관 교육 수료 (1:선택, 2:미선택)
        isKfood: '', // 한국외식산업협회 교육 수료 (1:선택, 2:미선택)
        imagePath: '', // 수료파일
        fileName: '', // 수료파일명
        isAgree: ''
      },
      currentIndex: 1
    }
  },
  async created() {
    await this.fetchData()
  },
  watch: {
    qualificationType: function(value) {
      this.form.qualificationType = value
      this.fnChange()
    }
  },
  computed: {
    diffYear: function() {
      if (
        !this.$Util.isEmpty(this.form.workStartDate) &&
        !this.$Util.isEmpty(this.form.workEndDate)
      ) {
        const startDate = this.$moment(this.form.workStartDate)
        const endDate = this.$moment(this.form.workEndDate)
        return endDate.diff(startDate, 'years')
      }
      return '-'
    },
    diffMonth: function() {
      if (
        !this.$Util.isEmpty(this.form.workStartDate) &&
        !this.$Util.isEmpty(this.form.workEndDate)
      ) {
        const startDate = this.$moment(this.form.workStartDate)
        const endDate = this.$moment(this.form.workEndDate)
        return endDate.diff(startDate, 'months') % 12
      }
      return '-'
    }
  },
  methods: {
    fnChange: function() {
      if (this.form.qualificationType === 1) {
        this.form.academyType = ''
        this.form.academyName = ''
        this.form.major = ''
        this.form.completedType = ''
        // 실무 경력
      }
      if (this.form.qualificationType === 2) {
        // 최종 학력
        this.form.work = ''
        this.form.workStartDate = ''
        this.form.workEndDate = ''
        this.form.workMonth = ''
      }
      this.form = this.$_.cloneDeep(this.form)
      this.currentIndex++
    },
    fetchData: async function() {
      const res = await this.$ManagerSvc.getMapExam({
        examinationNo: this.examinationNo
      })
      this.item = res.entity.exam
      this.form = res.entity.user
      // 회원정보와 시험신청 변수명이 다름
      this.form.koName = res.entity.user.name
      this.form.userBirth = res.entity.user.birth
      this.form.postCode = res.entity.user.postalCode
      this.form.userAddr = res.entity.user.address
      this.form.userAddr2 = res.entity.user.address2
      this.form.gender = 1
      this.form.qualificationType = 1
      if (!this.$Util.isEmpty(this.item.contents)) {
        this.fnModalInfo()
      }
    },
    fnBind: function({ roadAddress, zonecode }) {
      this.form.userAddr = roadAddress
      this.form.postCode = zonecode
    },
    fnModalInfo: function() {
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EXAM_INFO_POPUP,
        data: {},
        callBack: () => {}
      })
    },
    fnModalCert: function() {
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EXAM_CERT_POPUP,
        data: {},
        callBack: () => {}
      })
    },
    fnModal: function() {
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EDU_APPLY_POPUP,
        data: { applyType: 2 },
        callBack: this.fnSave
      })
    },
    fnSave: async function() {
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }
      this.form.qualificationType = this.qualificationType
      const params = this.$_.cloneDeep(this.form)
      console.log('result', params)
      params.examinationNo = this.examinationNo
      // 교육 수료 타입
      // params.eduCompletedType = params.eduCompletedType.join(',')      
      try {
        // 프로필 사진
        const res = await this.$CommonSvc.uploadFile({
          file: this.profileFile
        })
        params.userProfile = res.entity.storedFileName
        console.log(this.profileFile)
        console.log(res)
      } catch (err) {
        console.error(err)
      }
      try {
        // 수료파일
        const res = await this.$CommonSvc.uploadFile({
          file: this.certFile
        })
        params.imagePath = res.entity.storedFileName
      } catch (err) {
        console.error(err)
      }
      // 근무기간개월수
      if (this.qualificationType === 1) {
        const startDate = this.$moment(params.workStartDate)
        const endDate = this.$moment(params.workEndDate)
        params.workMonth = endDate.diff(startDate, 'months')
      }
      if(this.qualificationType === 2) {
        params.work = ''
        params.workStartDate = ''
        params.workEndDate = ''
      }
      console.log('result', params)
      const res = await this.$ManagerSvc.postIntExam(params)
      if (res.code === 1) {
        await this.$router.replace({ path: '/manager/exam/apply/done' })
      } else if (res.code === -6000) {
        alert(res.message)
      } else {
        alert(res.message)
      }
    },
    fnChangeSelectFile: function($event) {
      this.profileFile = $event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => {
        this.base64Profile = e.target.result
      }
      reader.readAsDataURL(this.profileFile)
    },
    fnFileChange: function(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.certFile = files[0]
      this.form.fileName = files[0].name
    }
  },
  validations: {
    profileFile: { required },
    certFile: { required },
    form: {
      koName: { required },
      enName: { required },
      userBirth: { required },
      gender: { required },
      email: { required },
      userAddr: { required },
      userPhone: { required },
      qualificationType: { required },
      work: {
        test: function(val) {
          if (this.qualificationType === 1) {
            return required(val)
          }
          return true
        }
      },
      workStartDate: {
        test: function(val) {
          if (this.qualificationType === 1) {
            return required(val)
          }
          return true
        }
      },
      workEndDate: {
        test: function(val) {
          if (this.qualificationType === 1) {
            return required(val)
          }
          return true
        }
      },
      academyType: {
        test: function(val) {
          if (this.qualificationType === 2) {
            return required(val)
          }
          return true
        }
      },
      academyName: {
        test: function(val) {
          if (this.qualificationType === 2) {
            return required(val)
          }
          return true
        }
      },
      major: {
        test: function(val) {
          if (this.qualificationType === 2) {
            return required(val)
          }
          return true
        }
      },
      completedType: {
        test: function(val) {
          if (this.qualificationType === 2) {
            return required(val)
          }
          return true
        }
      },
      isAgree: {
        test: function(val) {
          if (val === 1) {
            return true
          }
          return false
        }
      },
      isSelected: {
        test: function(val) {
          if(this.$Util.isEmpty(val) && this.$Util.isEmpty(this.form.isKfood)) { return false }
          if(val == 2 && this.form.isKfood == 2) { return false }
          if(val == 2 && this.$Util.isEmpty(this.form.isKfood)){ return false }
          if(this.$Util.isEmpty(val) && this.form.isKfood == 2){ return false }
          return true
        }
      }
    }
  }
}
</script>

<style scoped></style>
